import { render, staticRenderFns } from "./PresetOpeningSection.vue?vue&type=template&id=0f34881a&scoped=true"
import script from "./PresetOpeningSection.vue?vue&type=script&lang=js"
export * from "./PresetOpeningSection.vue?vue&type=script&lang=js"
import style0 from "./PresetOpeningSection.vue?vue&type=style&index=0&id=0f34881a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f34881a",
  null
  
)

export default component.exports